import React, { useEffect, useState } from "react";
import $ from "jquery";
import authBg from "../../assets/images/big/auth-bg.jpg";
import authBg2 from "../../assets/images/big/auth-bg2.jpg";
import logo from "../../assets/images/logo.png";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { loginmember } from "../../store/slices/userSlice";
import { createFormData } from "../../utils/common";
import { errorMessage, successMessage } from "../../utils/tostify";
import { useNavigate } from "react-router-dom";
import maa from "../../assets/images/big/maa.jpg";
import CryptoJS from "crypto-js";
import Swal from "sweetalert2";

const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [showModal, setShowModal] = useState(false); // This state isn't used in the provided code
  const [hidesidebar, setHideSidebar] = useState(false); // This state isn't directly set in the provided code but used in navigate

  useEffect(() => {
    $(".preloader").fadeOut();
  }, []);

  // Formik setup
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("Password is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true); // Disable the submit button immediately

      try {
        const encryptedPassword = CryptoJS.SHA256(values.password).toString();

        const finalValues = {
          ...values,
          password: encryptedPassword,
        };

      
        const s = await dispatch(loginmember(createFormData(finalValues))).unwrap(); // Use await and unwrap

        console.log(s);

        const validUptoDate = new Date(s.validupto);
        const today = new Date();
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(today.getMonth() - 3);

        localStorage.setItem("userData", JSON.stringify(s));
        localStorage.setItem("firstname", s.firstname);
        localStorage.setItem("lastname", s.lastname);
        localStorage.setItem("role", s.role);
        localStorage.setItem("password", s.password);
        localStorage.setItem("id", s.id);
        localStorage.setItem("validupto", s.validupto);
        localStorage.setItem("isLoggedId", "true");


        if (validUptoDate > today) {
          // Valid user
          navigate("/dashboard");
          successMessage("Login successful");
        } else {
          // Expired user
          const shouldHideSidebar = validUptoDate < threeMonthsAgo; // Determine if sidebar should be hidden
          successMessage("Your Membership expired, please renew");
          navigate('/renewmembershippaypal', {
            state: {
              hidesidebar: shouldHideSidebar,
            }
          });
        }
      } catch (error) {
        // This catch block handles errors from the loginmember dispatch or any unexpected errors
        console.error("Login failed:", error);
        Swal.fire("Error", error?.message || "Invalid Email/Password or a network error occurred.", "error");
        // You can also use your custom errorMessage utility if preferred:
        // errorMessage(error?.message || "Invalid Email/Password");
      } finally {
        setSubmitting(false); // Re-enable the submit button
      }
    },
  });

  // handleRenew is not directly used in the provided JSX for a button,
  // but it's defined. If it's meant for a future button, keep it.
  const handleRenew = () => {
    navigate("/renewmembershippaypal", {
      state: {
        hidesidebar: hidesidebar, // This 'hidesidebar' state isn't actively set within the component
      },
    });
  };

  return (
    <div className="main-wrapper">
      <div className="preloader">
        <div className="lds-ripple">
          <div className="lds-pos"></div>
          <div className="lds-pos"></div>
        </div>
      </div>
      <div
        className="auth-wrapper d-flex no-block justify-content-center align-items-center position-relative"
        style={{ background: `url(${authBg}) no-repeat center center` }}
      >
        <div className="auth-box row">
          <div
            className="col-lg-7 col-md-5 modal-bg-img"
            style={{ backgroundImage: `url(${authBg2})` }}
          >
            <img src={maa} width="100%" alt="Logo" />
          </div>
          <div className="col-lg-5 col-md-7 bg-white">
            <div className="p-3">
              <div className="text-center">
                <img src={logo} width="100%" alt="Logo" />
              </div>
              <h2 className="mt-3 text-center">Sign In</h2>
              <form className="mt-4" onSubmit={formik.handleSubmit}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group mb-3">
                      <label className="form-label text-dark" htmlFor="email">
                        Email
                      </label>
                      <input
                        className={`form-control ${formik.touched.email && formik.errors.email
                            ? "is-invalid"
                            : ""
                          }`}
                        id="email"
                        type="email"
                        placeholder="Enter your email"
                        style={{ textTransform: 'none' }}
                        {...formik.getFieldProps("email")}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="invalid-feedback">
                          {formik.errors.email}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group mb-3">
                      <label className="form-label text-dark" htmlFor="password">
                        Password
                      </label>
                      <div className="input-group">
                        <input
                          className={`form-control ${formik.touched.password && formik.errors.password
                              ? "is-invalid"
                              : ""
                            }`}
                          id="password"
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter your password"
                          {...formik.getFieldProps("password")}
                        />
                        <div
                          type="button"
                          className="btn btn-light border"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <i className="fa-solid fa-eye"></i>
                          ) : (
                            <i className="fa-solid fa-eye-slash"></i>
                          )}
                        </div>
                      </div>
                      {formik.touched.password && formik.errors.password && (
                        <div className="invalid-feedback">
                          {formik.errors.password}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-12 text-center">
                    <button
                      type="submit"
                      className="btn w-100 btn-dark"
                      disabled={formik.isSubmitting}
                    >
                      {formik.isSubmitting ? "Signing In..." : "Sign In"}
                    </button>
                  </div>
                  <div className="col-lg-12 text-center mt-5">
                    Don't have an account?{" "}
                    <a href="/register" className="text-danger">
                      Sign Up
                    </a>
                  </div>
                  <div className="col-lg-12 text-center">
                    Forgot Your Password?{" "}
                    <a href="/forgot-password" className="text-danger">
                      Forgot Password?
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;